import type { ErrorInfo, ReactNode } from 'react';
import React, { Component } from 'react';

import { logComponentError } from 'errors/errorHandler';
import Error from 'v2/components/Pages/Error';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    logComponentError(error);
  }

  public resetErrorState = () => {
    this.setState({
      hasError: false
    });
  };

  public render() {
    if (this.state.hasError) return <Error resetErrorState={this.resetErrorState} />;
    return this.props.children;
  }
}

export default ErrorBoundary;
